<template>
    <div class="md_web_home">
        <div class="md_swiper_box " >
            <swiper 
                v-if="list.length>0" 
                :options="swiperOption" 
                ref="mySwiper" 
                class="md_swiper_top_box">
                <swiper-slide v-for="(item, index) in list" :key="index">
                    <img :src="item" alt="" />
                </swiper-slide>
                <div class="md_swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <div class="md_data_change">
            <div class="data_item_box" v-for="(item,index) of data_change" :key="index">
                <countTo 
                    class="count_box" 
                    :startVal='0' 
                    separator=""
                    :endVal='Number( item.number)' 
                    :duration='3000'></countTo>
                <div class="title">{{ item.title }}</div>
                <div class="little_title">{{ item.description }}</div>
            </div>
        </div>
        <div class="md_homepage ">
            <div class="web_index_img_box"></div>
        </div>
        <div class="md_pro_ana_ser">
            <div class="pas_title">婧贤人才产品与服务</div>
            <div class="pas_item_box">
                <div  class="box" @click="seedetails(item)"  v-for="(item,index) in proandserlist" :key="index">
                    <img class="img_box" :src="item.bg" alt="">
                    <div class="two_box" >
                        <img class="two_img_box" :src="item.icon" alt="" srcset="">
                        <div class="two_font">{{ item.title }}</div>
                        <div class="two_font_title">{{ item.subtitle }}</div>
                        <div class="two_botton">查看详情</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="md_case_box">
            <div class="case_title">服务案例</div>
            <swiper 
                v-if="list.length>0" 
                ref="caseswiper"
                :options="swiperOption1" 
                class="md_swiper_top_box">
                <swiper-slide 
                    v-for="(item, index) in corelist" 
                    :key="index">
                    <img :src="item.resource" alt="" />
                    <div class="case_botton_ins">
                        <div class="swiper_title">{{  item.title }}</div>
                    </div>
                </swiper-slide>
                <div class="md_swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <div class="md_core_values">
            <div class="cv_title">核心价值</div>
            <div class="cv_item_box">
               <div class="item_box" v-for="(item,index) in worth" :key="index">
                    <div class="item_top_box">
                        <img class="core_img_box" 
                            :src="item.icon" alt="">
                        <div class="core_font_box">{{ item.title }}</div>
                    </div>
                    <div class="item_content" v-html="item.content"></div>
               </div>
            </div>
        </div>
        <bottomnav :display="display"></bottomnav>
    </div>
</template>
<script>

import flexbotton from './flexbotton.vue'
import bottomnav from './bottomnav.vue';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import countTo from 'vue-count-to';
import "swiper/dist/css/swiper.css";

export default{
    components: { 
        flexbotton,swiper,swiperSlide,countTo,bottomnav
    },
    props:['list','corelist','data_change'],
    data(){
        return{
            display:true,
            // list:[],
            swiperOption1:{
               loop: true,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                // 显示分页
                pagination: {
                    el: ".md_swiper-pagination",
                    clickable: true, 
                },
                on:{
                    // slideChangeTransitionEnd:function(){
                    //     console.log(111, this.corelist);
                    // },
                },
            },
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                // 显示分页
                pagination: {
                    el: ".md_swiper-pagination",
                    clickable: true, 
                },
            },
            barlist:[
                {id:1,title:'产品与服务',path:'/proser'},
                {id:2,title:'HR数字化转型',path:'/hr'},
                {id:3,title:'服务案例',path:'/cases'},
                {id:4,title:'招聘信息',path:'/horecruitmentme'},
                {id:5,title:'关于婧贤',path:'/about'},
            ],
            botNavigationlist:[
                {title:'人力资源外包',path:'/proser',type:1,},
                {title:'劳务派遣服务',path:'/proser',type:2,},
                {title:'岗位外包服务',path:'/proser',type:3,},
                {title:'HR数字化转型',path:'/hr'},
            ],
            aboutlist:[
                {title:'产品与服务',path:'/proser'},
                {title:'服务案例',path:'/cases'},
                {title:'联系我们',path:'/about'},   
            ],
            proandserlist:[
                {
                    type:1,
                    id:1,
                    path:'/proser',
                    title:'人力资源事务外包',
                    subtitle:'有效地提高效率，并使外包职能的运作更加专业化。',
                    icon:require('../../../assets/icons/官网首页_slices/矢量智能对象@3x.png'),
                    bg:require('../../../assets/icons/官网首页_slices/1@3x.png')
                },
                {   
                    type:2,
                    id:1,
                    path:'/proser',
                    title:'劳务派遣服务',
                    subtitle:'灵活用工形式，劳动力的使用和管理分离。',
                    icon:require('../../../assets/icons/官网首页_slices/矢量智能对象@3x(1).png'),
                    bg:require('../../../assets/icons/官网首页_slices/2@3x.png')
                },
                {
                    type:3,
                    id:1,
                    path:'/proser',
                    title:'岗位外包服务',
                    subtitle:'降低成本、提高效率、优化资源配置',
                    icon:require('../../../assets/icons/官网首页_slices/矢量智能对象@3x(2).png'),
                    bg:require('../../../assets/icons/官网首页_slices/3@3x.png')
                },
                {
                    type:1,
                    id:2,
                    path:'/hr',
                    title:'HR数字化转型',
                    subtitle:'以颠覆性力量重构人力资源管理逻辑。',
                    icon:require('../../../assets/icons/官网首页_slices/矢量智能对象@3x(3).png'),
                    bg:require('../../../assets/icons/官网首页_slices/4@3x.png')
                },
            ],
            worth:[
                {
                    icon:require('../../../assets/icons/官网首页_slices/value_01.png'),
                    title:'使命',
                    content:'以人为本，以服务为先</br>成就人才价值，助力企业腾飞'
                },
                {
                    icon:require('../../../assets/icons/官网首页_slices/value_02.png'),
                    title:'愿景',
                    content:'依托人才与科技</br>成为人力资源服务行业数字赋能与科技创新引领者'
                },
                {
                    icon:require('../../../assets/icons/官网首页_slices/value_03.png'),
                    title:'价值观',
                    content:'人尽其才，才尽其用'
                },
            ],
            drawer:true,
            mdnav:[
                {id:0,title:'首页'},
                {id:1,title:'产品与服务'},
                {id:2,title:'HR数字化转型'},
                {id:3,title:'服务案例'},
                {id:4,title:'招聘信息'},
                {id:5,title:'关于婧贤'},
            ],
            navaction:'',
            swiperInstance:null
        }
    },
    created(){
       
    },
    mounted(){
        this.navaction=this.mdnav[0].id  
    },
    methods:{ 
        mdnavclick(item){
            this.navaction=item.id
        },
        opennav(){
            this.drawer=true
        },
     
        botNavigation(item){
              this.$router.push({
                path: item.path,
                query:{
                    type:item.type
                }
            })
        },
        seedetails(item){
            this.$store.commit('mdnavaction',item.id)
            this.$store.commit('active',item.type)
            this.$emit('cusscroll')
        },
        barclick(item){
            this.$store.commit('detailsbottom',true)
            this.$router.push({
                path: item.path,
                query:{
                    id:item.id
                }
            })
        }
    },

}
</script>
<style lang="less" scoped> 
.md_web_home{
    .md_core_values{
        width:100%;
        box-sizing: border-box;
        .cv_title{
            font-size: 46px;
            font-weight: 400;
            color: #101010;;
            margin-top: 65px;
            margin-bottom: 45px;
            text-align: center
        }
        .cv_item_box{
            margin-bottom: 25px;
            .item_box{
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column; 
                color: #101010;
                .item_top_box{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    .core_img_box{
                        width: 100px;
                        height: 100px;
                        margin-bottom: 25px;
                    }
                    .core_font_box{
                        font-size: 35px;
                        font-weight: 400;
                        margin-bottom: 5px;
                    }
                }
                .item_content{
                    text-align: center;
                    color: #606060;
                    margin-bottom: 25px;
                    font-size: 35px;
                    line-height: 50px;

                }
            }
        }
    }
    .md_case_box{
        width:100%;
        box-sizing: border-box;
        position: relative;
        .case_title{
            font-size: 46px;
            font-weight: 400;
            color: #101010;;
            margin-top: 65px;
            margin-bottom: 45px;
            text-align: center
        }
        .case_botton_ins{
            width: 100%;
            height: 100px;
            background: rgba(0, 0, 0, 0.5);  
            position: absolute;
            bottom: 0px;
            z-index: 3;
            
            .md_case_swiper_title{
                box-sizing: border-box;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                text-align: center;
            }
        }
        .md_swiper_top_box{
            height:550px;
            box-sizing: border-box;
            position: relative;
            .md_swiper-pagination{
                position: absolute;
                bottom: 60px;
                z-index: 2;
                width: 100%;
                height: 20px;
                align-items: center;
                display: flex;
                justify-content: center;
                /deep/.swiper-pagination-bullet{
                    margin: 0px 2px;
                    width: 20px;
                    height: 20px;
                    border-radius: 0px;
                    background: #fff;
                    border-radius: 50%;
                    opacity: 0.2;
                }
                /deep/.swiper-pagination-bullet-active{
                    background: #FFFFFF;
                    opacity: 1;
                }
            }
            .swiper-container {
                width: 100%;
                border-radius: 5px;
                padding-bottom: 2.5rem;
            }
            .swiper-slide {
                text-align: center;
                // margin: 0 -20px;
                position: relative;
                z-index: 1;
                .swiper_title{
                    z-index: 9 !important;
                    position: absolute;
                    bottom: 15px;
                    width: 100%;
                    font-size: 30px;
                    color: #FFFFFF;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis
                }
                img {
                    width:100%;
                    height: 100%;
                }
            }
        }   
    }
    .md_pro_ana_ser{
        width:100%;
        box-sizing: border-box;
        .pas_title{
            font-size: 46px;
            font-weight: 400;
            color: #101010;;
            margin-top: 65px;
            margin-bottom: 45px;
            text-align: center
        }
        .pas_item_box{
            display: flex;  
            flex-wrap: wrap;
            box-sizing: border-box;
            background: #1B1E2D;
            width: 100%;
            height: 1240px;
            padding: 0px 40px;
            .box{
                width: 50%;
                height: 620px;
                border-radius: 5px;
                box-sizing: border-box;
                position: relative;
                overflow: hidden;
                .two_box{
                    width: 100%;
                    height: 100%;
                    border: 1px solid black;
                    position: absolute;
                    top: 0px;      
                    right: 0px;
                    z-index: 2;
                    background: rgba(25, 25, 25, 0.6);
                    box-sizing: border-box;
                    .two_font_title{
                        opacity:0;
                        width: 257px;
                        height: 90px;
                        position: absolute;
                        text-align: left;
                        color: #fff;
                        top: 65%;
                        text-align: center;
                        left: 20%;
                        transition: all 0.5s ease;
                    }
                    .two_botton{
                        width: 200px;
                        height: 54px;
                        border-radius: 50px;
                        position: absolute;
                        font-size: 26px;
                        text-align: left;
                        border: 1px solid #fff;
                        color: #fff;
                        top: 90%;
                        right: 23%;
                        opacity: 0;
                        text-align: center;
                        line-height: 54px;
                        transition: all 0.5s ease-in-out;
                        z-index: 1;
                    
                    }
                    .two_font{
                        transition: 1s;
                        color: #fff;
                        font-weight: bold;
                        position: absolute;
                        top: 57%;
                        box-sizing: border-box;
                        text-align: center;
                        width: 100%;
                        font-size: 38px;
                        transition: all 0.5s ease;
                    }
                    .two_img_box{ 
                        transition: 1s;
                        position: absolute;
                        top: 50%;
                        right: 50%;
                        width: 90px;
                        height: 90px;
                        margin-top: -85px;
                        margin-right: -40px;
                        transition: all 0.5s ease;
                        
                    }
                }
                .img_box{
                    width: 100%;
                    height: 100%;
                    border-radius: 5px;
                    box-sizing: border-box;
                    z-index: 1;
                }
            }
        }
    }
    .md_homepage{
        box-sizing: border-box;
        width: 100%;
        height: 320px;
        padding: 0px 40px;
        .web_index_img_box{
            // width: 1600px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            background: url('../../../assets/icons/官网首页_slices/宣传图@3x.png') no-repeat;
            background-size: 100% 100%;
        }
    }
    .md_data_change{
        position: relative;
        width: 100%;
        height: 340px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;
        padding: 0px 12px;
        .data_item_box{
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .count_box{
                font-weight: bold;
                font-weight: 600;
                font-size: 60px;
                color: #027DFC;
            }
            .title{
                font-weight: bold;
                font-size: 28px;
                color: #101010;
                margin-top: 5px;
            }
            .little_title{
                font-weight: 400;
                font-size: 26px;
                color: #606060;
                margin-top: 8px;
            }
        }
    }
    .md_swiper_box{
        position: relative; 
        width: 100%;
        height: 440px;
        box-sizing: border-box;
        .md_swiper_top_box{
            width: 100%;
            height: 100%;
            position: relative;
            .md_swiper-pagination{
                position: absolute;
                bottom: 10px;
                z-index: 8;
                display: flex;
                justify-content: center;
                /deep/.swiper-pagination-bullet{
                    width: 50px;
                    height: 3px;
                    border-radius: 0px;
                    background: #fff;
                    opacity: 0.2;
                }
                /deep/.swiper-pagination-bullet-active{
                    background: #FFFFFF;
                    opacity: 1;
                }
            
            }
            
            .swiper-container {
                width: 100%;
                border-radius: 5px;
                padding-bottom: 2.5rem;
            }
            .swiper-slide {
                text-align: center;
                // margin: 0 -20px;
                position: relative;
                z-index: 1;
                img {
                    width:100%;
                    height: 100%;
                }
            }
        }    
    }
}

</style>